class CartDrawer extends SlidingDrawer {
  constructor() {
    super();
    this.progressElement = this.querySelector(".sm-drawer-progress");
  }
  open(opener) {
    super.open(opener);
    document.body.dispatchEvent(
      new CustomEvent("cartDrawerOpened", {
        detail: {
          source: this
        }
      })
    );
  }
  renderContents(parsedState, opener) {
    var _a;
    (_a = this.querySelector("cart-drawer-items")) == null ? void 0 : _a.classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
      elementToReplace.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.section || section.id],
        section.selector
      );
    });
    setTimeout(() => {
      this.open(opener);
    });
  }
  getSectionInnerHTML(html, selector = ".shopify-section") {
    var _a;
    return (_a = new DOMParser().parseFromString(html, "text/html").querySelector(selector)) == null ? void 0 : _a.innerHTML;
  }
  getSectionsToRender() {
    var _a;
    return [
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: "#cart-icon-bubble"
      },
      {
        id: "announcement-bar",
        section: (_a = document.getElementById("announcement-bar")) == null ? void 0 : _a.dataset.id,
        selector: ".shopify-section"
      },
      {
        id: "cart-drawer",
        selector: ".sm-cart-drawer__container"
      }
    ];
  }
  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector);
  }
  setActiveElement(element) {
    this.activeElement = element;
  }
  enableLoading() {
    var _a;
    (_a = this.progressElement) == null ? void 0 : _a.setAttribute("data-status", "processing");
  }
  disableLoading() {
    var _a;
    (_a = this.progressElement) == null ? void 0 : _a.setAttribute("data-status", "done");
    setTimeout(() => {
      var _a2;
      (_a2 = this.progressElement) == null ? void 0 : _a2.removeAttribute("data-status");
    }, 650);
  }
}
customElements.define("cart-drawer", CartDrawer);
class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    var _a;
    return [
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: "#cart-icon-bubble"
      },
      {
        id: "announcement-bar",
        section: (_a = document.getElementById("announcement-bar")) == null ? void 0 : _a.dataset.id,
        selector: ".shopify-section"
      },
      {
        id: "cart-drawer",
        section: "cart-drawer",
        selector: ".sm-drawer__container"
      }
    ];
  }
}
customElements.define("cart-drawer-items", CartDrawerItems);
